import sendTelemetryEvent from '@/Sparrow/Services/Telemetry';
import { usePage } from '@inertiajs/vue3';
import { useEventListener } from '@vueuse/core';

export function useImageErrorTracking() {
  useEventListener(
    document,
    'error',
    async (event) => {
      if (!(event.target instanceof HTMLImageElement)) return;

      const img = event.target;
      const { src } = img;
      if (!src || src.startsWith('data:')) return;

      const page = usePage();
      const payload = {
        type: 'image_load_error',
        image_src: src,
        route: {
          name: page.component || '',
          path: window.location.pathname,
          url: window.location.href,
        },
        timestamp: new Date().toISOString(),
      };

      try {
        await sendTelemetryEvent(payload);
      } catch {
        // silence errors
      }
    },
    { capture: true },
  );
}

export default useImageErrorTracking;
